import { getPostRequestFetchOptions } from "../legacyClients";

export interface Request {
  url: string;
  prevState: "voted-up" | "no-vote";
}

export interface Response {
  ok: boolean;
}

export const vote = async (spec: Request) => {
  const { url, prevState } = spec;
  const fetchOptions = await getPostRequestFetchOptions();
  const response = await fetch(url, {
    ...fetchOptions,
    method: prevState === "voted-up" ? "DELETE" : "POST",
  });

  return { ok: response.ok };
};
